var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hourglass thinly-shadowed"},[_c('img',{staticClass:"hourglass-img",attrs:{"src":require("@/assets/img/utils/hourglass.svg")}})])
}]

export { render, staticRenderFns }